export class TransportModeHelper {
    static transform(loadType: string, transportMode: string, showAirLoadType = false): string | null {
        if (transportMode === 'TRUCK' && loadType === 'lcl') {
            return 'ltl';
        }
        if (transportMode === 'TRUCK' && loadType === 'fcl') {
            return 'ftl';
        }

        if (transportMode === 'AIR') {
            return showAirLoadType ? 'lse' : null;
        }

        return loadType;
    }
}
